import React, { useContext } from 'react';
import styled from 'styled-components';
import { Icon, Text, theme } from 'components';
import { AuthContext } from 'contexts';
import AppointmentDeskContext from './AppointmentDeskContext';

const ServiceLabels: React.FC<{ labels: string[] }> = ({ labels }) => (
    <StyledBulletWrapper>
      {labels.map((label, index) => (
        <StyledPointWrapper key={label}>
          <Icon type="antdCheckCircleFilled" color="info" width={12} />
          <StyledSmallText
            $marginLeft={9}
            $secondary
            data-cy={`details-text-${index + 1}`}
          >
            {label}
          </StyledSmallText>
        </StyledPointWrapper>
      ))}
    </StyledBulletWrapper>
  );

export default ServiceLabels;

const StyledSmallText = styled.div<{
  $marginBottom?: number;
  $marginLeft?: number;
  $secondary?: boolean;
}>`
  font-size: 14px;
  line-height: 22px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom || 0}px;
  margin-left: ${({ $marginLeft }) => $marginLeft || 0}px;
  ${({ $secondary }) => $secondary && `color: ${theme.gray8};`}
`;

const StyledBulletWrapper = styled.div`
  width: 100%;
  margin-bottom: 40px;
`;

const StyledPointWrapper = styled.div`
  margin-bottom: 4px;
  display: flex;
  align-items: center;
`;
